import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareBoardEmbedRoute: InvariantJiraRoute = {
	name: 'software-boards-embed',
	exact: true,
	path: '/jira/software/projects/:projectKey/boards/:boardId/embed',
};
